import PageLoader from "../../../components/PageLoader"
import { OidcConsumer } from "../../../providers/OidcProvider"

const OIDCCallbackPage = () => {
  return (
    <OidcConsumer>
      {({ signinRedirectCallback }) => {
        signinRedirectCallback()
        return <PageLoader />
      }}
    </OidcConsumer>
  )
}

export default OIDCCallbackPage